import dayjs from 'dayjs';
import { DATE_FORMAT } from 'v2/core/date/date';

const SIGNUP_TIME_METADATA_KEY = 'signup_time';

interface FormatFeedbackMetadataValueIfRequiredParams {
  displayName: string;
  value: string;
}

export const formatFeedbackMetadataValueIfRequired = ({
  displayName,
  value,
}: FormatFeedbackMetadataValueIfRequiredParams) => {
  if (!value) {
    return '--';
  }

  return displayName === SIGNUP_TIME_METADATA_KEY
    ? dayjs(value).tz().format(DATE_FORMAT)
    : value;
};
